import qs from 'query-string';

export function queryStringParser(queryString, queryParams) {
  return qs.parse(queryString, { ignoreQueryPrefix: true })[queryParams];
}
